<template>
    <CreatePopup v-if="newPrDialog" v-model="newPrDialog" :flowtype="'Press Release'" @create="addNewPr($event)" />
    <div class="mainComponents">
        <div v-if="comingSoon" class="no-press-release">
            <ComingSoon title="Draft Your" subtitle="Press Releases" 
        description="Create press releases to announce your news with clarity and impact. Create compelling announcements that capture attention and drive action."
        :title-image="require('@/assets/icons/pr-colored.svg')" />
   
        </div>
        <div v-else-if="prLoader" class="no-data">
            <RotatingLoader :size="30" :speed="0.6" label="Loading..." />
        </div>

        <div v-else class="press-release">
            <div class="TitleSection">
                <div class="title">Press Release</div>
                <button v-if="pressReleases.length > 0" @click=" newPrDialog = true" class="new-pr-container">
                    <Svg :src="require('@/assets/icons/create-icon.svg')" alt="create"></Svg>
                    <span>Create</span>
                </button>
            </div>

            <div v-if="draftCount == 0 && completedCount == 0 && !filterState && !filterType" class="no-press-release">
                <EmptyState :title="'No Press Release Created!'" :stage="'DRAFT'"
                    :subTitle="'Create a new Press Release to see it listed here.'" @create-dialog="newPrDialog = true">
                </EmptyState>
            </div>

            <div v-else class="body-content">
                <div class="toggle-container">
                    <div class="toggle-buttons">
                        <button class="toggle-button" :class="{ active: selectedTab === 'draft' }"
                            @click="toggleTab('draft')">
                            Draft<span> ({{ draftCount }})</span>
                        </button>
                        <button class="toggle-button" :class="{ active: selectedTab === 'completed' }"
                            @click="toggleTab('completed')">
                            Complete <span>({{ completedCount }})</span>
                        </button>
                    </div>

                    <div v-if="(selectedTab === 'draft' && draftCount !== 0) || (selectedTab === 'completed' && completedCount !== 0) || filterState || filterType"
                        class="filter-Page">
                        <v-menu v-model="dateMenu" :close-on-content-click="false">
                            <template v-slot:activator="{ props }">
                                <div class="selected-date-container">
                                    <button class="filter-btn" v-bind="props">
                                        <Svg :src="require('@/assets/icons/calendar.svg')" stroke='#030712'></Svg>
                                        <span
                                            v-if="filterStartDate && filterEndDate && filterStartDate === filterEndDate">{{
                                                convertEpochToDate(filterStartDate) }}</span>
                                        <span v-else-if="filterStartDate && filterEndDate">{{
                                            convertEpochToDate(filterStartDate) + ' - ' +
                                            convertEpochToDate(filterEndDate) }}</span>
                                        <span class="text" v-else>Filter by Date</span>
                                    </button>
                                    <v-icon v-if="filterStartDate" @click="clearFilterDates">mdi-close</v-icon>
                                </div>
                            </template>
                            <v-date-picker v-model="selectedDate" :max="new Date()" multiple="range"
                                @update:model-value="updateFilterDate(false)">
                                <template #actions>
                                    <div class="action-btns">
                                        <v-btn @click="clearFilterDates" class="ok-btn">Cancel</v-btn>
                                        <v-btn @click="updateFilterDate(true)" class="ok-btn"
                                            :disabled="selectedDate.length === 0">OK</v-btn>
                                    </div>
                                </template>
                            </v-date-picker>
                        </v-menu>
                        <v-select class="pr-filter-select" v-model="filterPrType" variant="plain" :items="prOptions"
                            hide-details :clearable="filterPrType !== 'All'" @click:clear="filterPrType = 'All'"
                            item-title="typeName" item-value="typeId" @update:model-value="fetchAllPr">
                            <template #selection="{ item }">
                                Type: {{ item?.title || 'All' }}
                            </template>
                        </v-select>

                        <div class="view-toggle-container">
                            <button @click="selectedView = 'list'"
                                :class="{ 'active': selectedView === 'list', 'view-icon': true }">
                                <Svg :src="require('@/assets/icons/list.svg')"></Svg>
                            </button>
                            <button @click="selectedView = 'grid'"
                                :class="{ 'active': selectedView === 'grid', 'view-icon': true }">
                                <Svg :src="require('@/assets/icons/grid.svg')"></Svg>

                            </button>
                        </div>
                    </div>
                </div>
                <RenamePopup v-if="isEditing" :docName="currentRenameItem.prName" :id="currentRenameItem.prId"
                    :isEditing="isEditing" @update-isEdit="isEditing = $event"
                    @updated-prTitle="handleTitleUpdate($event)" flowType="pressRelease" />
                <div v-if="selectedTab === 'draft' && draftCount === 0" class="no-press-release">
                    <EmptyState :title="'No Draft Press Release!'" :stage="'DRAFT'"
                        :filter="(filterState || filterType)"
                        :subTitle="(filterState || filterType) ? 'No press releases match your filters.' : 'Create a new Press Release to see it listed here'"
                        @create-dialog="newPrDialog = true">
                    </EmptyState>
                </div>
                <div v-if="selectedTab === 'completed' && completedCount === 0" class="no-press-release">
                    <EmptyState :title="'No completed Press Release!'" :stage="'COMPLETED'"
                        :subTitle="(filterState || filterType) ? 'No press releases match your filters.' : 'Create a new Press Release to see it listed here'"
                        @create-dialog="newPrDialog = true">
                    </EmptyState>
                </div>
                <div class="pr-grid" v-else-if="selectedView === 'grid' && pressReleases.length > 0">
                    <div v-for="(item, index) in pressReleases" :key="index" class="pr-card"
                        @click="goToPrDetails(event, { item })">
                        <div class="pr-more-container">
                            <div class="pr-type" :class="item.typeClass">{{ item.prType }}</div>
                            <div class="more-container">
                                <v-menu v-model="item.showMoreMenu" :close-on-content-click="false">
                                    <template v-slot:activator="{ props }">
                                        <img :src="require('@/assets/icons/more.svg')" alt="more" v-bind="props">
                                    </template>
                                    <div class="more-options-contaioner">
                                        <div @click="editPr(item)" class="bottom-border more-option-img-wrapper">
                                            <img :src="require('@/assets/icons/rename.svg')" alt="rename">
                                            <p>Rename</p>
                                        </div>
                                        <div class="more-option-img-wrapper" @click="deletePr(item)">
                                            <Svg :src="require('@/assets/icons/delete.svg')" fill='#404040'
                                                alt="delete"></Svg>
                                            <p>Delete</p>
                                        </div>
                                    </div>
                                </v-menu>
                            </div>
                        </div>
                        <div class="pr-content">{{ item.prName }}</div>
                        <div class="pr-footer">
                            <div class="avatar">
                                <img v-if="item.profileAvatar" :src="item.profileAvatar" class="profile-icon"
                                    alt="User Avatar" />
                                <div class="profile-icon no-avatar" v-else>{{ item?.createdByName?.[0] }}</div>
                                <div class="author">{{ item.createdByName }}</div>
                            </div>
                            <div class="meta-info">
                                <div class="timestamp">{{ item.updatedAtGrid }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="table-container" v-else-if="pressReleases.length > 0">
                    <v-data-table class="table-wrapper" :headers="tableHeaders" :items="pressReleases" :hover="true"
                        ref="prTable" :items-per-page="itemsPerPage" :page="page" @click:row="goToPrDetails">

                        <template v-slot:[`item.prName`]="{ item }">
                            <div class="prName-wrapper">
                                <strong>{{ item.prName }}</strong>
                            </div>
                        </template>
                        <template v-slot:[`item.prType`]="{ item }">
                            <div class="table-pr-type" :class="item.typeClass">
                                {{ item.prType }}
                            </div>
                        </template>

                        <template v-slot:[`item.createdByName`]="{ item }">
                            <div class="avatar">
                                <img v-if="item.profileAvatar" :src="item.profileAvatar" class="profile-icon"
                                    alt="User Avatar" />
                                <div class="profile-icon no-avatar" v-else>{{ item?.createdByName?.[0] }}</div>
                                <div class="author">{{ item.createdByName }}</div>
                            </div>

                        </template>
                        <template v-slot:[`item.createdAt`]="{ item }">
                            {{ item.createdAtList }}


                        </template>
                        <template v-slot:[`item.updatedAt`]="{ item }">
                            {{ convertEpochToDate(item.updatedAt) }}

                        </template>
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-menu v-model="item.showMoreMenu" :close-on-content-click="false">
                                <template v-slot:activator="{ props }">
                                    <div class="more-button-wrapper">
                                        <img style="height: 16px; width: 16px;"
                                            :src="require('@/assets/icons/more.svg')" alt="more" v-bind="props">
                                    </div>
                                </template>
                                <div class="more-options-contaioner">
                                    <div @click="editPr(item)" class="bottom-border more-option-img-wrapper">
                                        <img :src="require('@/assets/icons/rename.svg')" alt="rename">
                                        <p>Rename</p>
                                    </div>
                                    <div class="more-option-img-wrapper" @click="deletePr(item)">
                                        <Svg :src="require('@/assets/icons/delete.svg')" fill='#404040'
                                            alt="delete"></Svg>
                                        <p>Delete</p>
                                    </div>
                                </div>
                            </v-menu>
                        </template>
                    </v-data-table>
                </div>
            </div>
        </div>
    </div>
     <CommonPopup v-if="showCommonPopup" :showCommonPopup="showCommonPopup" :popupType="popupType"
        @confirm-action="handleConfirmation" />


</template>

<script>
import DatePicker from '@/components/DatePicker.vue';
import axiosInstance from '@/axiosInterceptor';
import moment from 'moment-timezone';
import { Eventbus } from '@/plugins/eventBus';
import CommonPopup from '@/components/CommonPopup.vue';
import RenamePopup from '@/components/RenamePopup.vue';
import RotatingLoader from '@/components/CircularProgressBar.vue'
import EmptyState from '@/components/EmptyState.vue';
import CreatePopup from '@/components/CreatePopup.vue';
import ComingSoon from '@/components/ComingSoon.vue';
export default {

    components: {
        DatePicker,
        CommonPopup,
        RenamePopup,
        RotatingLoader,
        EmptyState,
        CreatePopup,
        ComingSoon
    },
    data() {
        return {
            comingSoon: false,
            newPrDialog: false,
            isFormValid: false,
            buttonLoader: false,
            docName: null,
            completedCount: null,
            draftCount: null,
            prType: null,
            filterPrType: "All",
            selectedTab: null,
            prOptions: [],
            selectedDate: [],
            filterStartDate: null,
            filterEndDate: null,
            dateMenu: false,
            selectRules: [
                v => !!v || 'This field is required',
                v => v.length > 0 || 'This field is required'
            ],
            pressReleases: [],
            prLoader: false,
            showCommonPopup: false,
            popupType: 'delete',
            deletedPr: null,
            selectedView: 'grid',
            tableHeaders: [
                { title: 'Document Name', key: 'prName' },
                { title: 'Type', key: 'prType', align: 'center' },
                { title: 'Created By', key: 'createdByName' },
                { title: 'Created On', key: 'createdAt' },
                { title: 'Last Edited', key: 'updatedAt' },
                { title: 'Actions', key: 'actions' },
            ],
            perPage: [
                { name: '5', value: 5 },
                { name: '10', value: 10 },
                { name: '25', value: 25 },
                { name: 'All', value: -1 }
            ],
            page: 1,
            itemsPerPage: 10,
            isEditing: false,
            currentRenameItem: {},
            filterOptions: [],
            filterState: false,
            prFilter: [],
            filteredDraft: [],
            filteredComplted: [],
            filterType: false
        };
    },
    watch: {
        newPrDialog() {
            if (!this.newPrDialog) {
                this.resetPopupData();
            }
        }
    },
    computed: {
        totalPages() {
            return Math.ceil(this.pressReleases.length / this.itemsPerPage);
        }
    },
    methods: {
        resetPopupData() {
            this.docName = null;
            this.prType = null;
        },
        handleConfirmation(val) {
            this.showCommonPopup = false;
            if (val === 'yes') {
                axiosInstance.put('/pr/delete', { prId: this.deletedPr.prId, prTypeId: this.deletedPr.prTypeId })
                    .then((response) => {
                        if (response.status === 204) {
                            Eventbus.emit('commonSnackbar', {
                                snackType: "save",
                                message: 'Pr deleted successfully!'
                            });
                            this.fetchAllPr();
                        }
                    })
                    .catch((error) => {
                        console.error('Error while deleting PR', error);
                        Eventbus.emit('commonSnackbar', {
                            snackType: "failed",
                            message: 'Failed to delete PR'
                        });
                    })
                    .finally(() => {
                        this.deletedPr = null;
                        this.showCommonPopup = false;
                    })
            }
        },
        async handleTitleUpdate(event) {
            this.currentRenameItem.prName = event
            await this.fetchAllPr();
        },
        editPr(item) {
            this.isEditing = true;
            this.currentRenameItem = item

        },
        deletePr(item) {
            this.showCommonPopup = true;
            this.deletedPr = item;
        },
        removeNumbers() {
            this.docName = this.docName.replace(/[0-9]/g, '');
        },
        convertEpochToDate(time) {
            return moment(time).format('DD/MM/YYYY');
        },

        async updateFilterDate(okBtnClicked) {
            if (this.selectedDate.length > 1) {
                this.filterStartDate = moment(this.selectedDate[0]).valueOf();
                this.filterEndDate = moment(this.selectedDate[this.selectedDate.length - 1]).valueOf();
                this.dateMenu = false;
                this.fetchAllPr();
            } else if (okBtnClicked) {
                this.filterStartDate = moment(this.selectedDate[0]).valueOf();
                this.filterEndDate = this.filterStartDate;
                this.dateMenu = false;
                this.fetchAllPr();
            }
        },
        clearFilterDates() {
            this.selectedDate = [];
            this.filterStartDate = null;
            this.filterEndDate = null;
            this.dateMenu = false;
            this.fetchAllPr();
        },

        searchDateMenu() {
            this.searchDateMenu = True;
        },
        setDate(date) {
            this.selectedDate = date
        },

        toggleTab(tab) {
            this.selectedTab = tab;
            this.fetchAllPr();
            this.$router.push({
                path: '/pr',
                query: {
                    status: this.selectedTab.toUpperCase()
                }
            });

        },

        goToPrDetails(event, { item }) {
            this.$router.push({
                name: 'PrDetails',
                params: { prId: item.prId }
            });
        },

        async fetchPrTypes() {
            await axiosInstance.get('/category')
                .then((response) => {
                    this.filterOptions = [
                        { typeId: "All", typeName: "All" },
                        ...response.data.data
                    ];
                    this.prOptions = response.data.data;
                });
        },

        async fetchAllPr() {
            this.prLoader = true;
            try {
                const response = await axiosInstance.get('/pr');
                let allPr = response.data.data || [];
                if (this.filterStartDate && this.filterEndDate) {
                    allPr = allPr.filter(pr => {
                        return pr.createdAt >= this.filterStartDate && pr.createdAt <= this.filterEndDate;
                    });
                    this.filterState = true;
                }

                this.filteredDraft = allPr.filter(pr => pr.statusValue === 'DRAFT').sort((a, b) => b.updatedAt - a.updatedAt);
                this.filteredCompleted = allPr.filter(pr => pr.statusValue === 'COMPLETED').sort((a, b) => b.updatedAt - a.updatedAt);

                if (this.filterPrType && this.filterPrType !== 'All') {
                    this.filterType = true;
                    this.filteredDraft = this.filteredDraft.filter(pr => pr.prTypeId === this.filterPrType);
                    this.filteredCompleted = this.filteredCompleted.filter(pr => pr.prTypeId === this.filterPrType);
                    this.typeFilterState = true;
                }

                this.draftCount = this.filteredDraft.length;
                this.completedCount = this.filteredCompleted.length;

                this.pressReleases = this.selectedTab === 'draft' ? this.filteredDraft : this.filteredCompleted;

                this.pressReleases.forEach(pr => {
                    const foundOption = this.prOptions.find(option => option.typeId === pr.prTypeId);
                    pr.prType = foundOption ? foundOption.typeName : "Unknown Type";
                    pr.createdAtGrid = moment(pr.createdAt).format("Do MMM, YYYY hh:mmA");
                    pr.updatedAtGrid = moment(pr.updatedAt).format("Do MMM, YYYY hh:mmA");
                    pr.createdAtList = moment(pr.createdAt).format("DD/MM/YYYY");
                    pr.updatedAtList = moment(pr.updatedAt).format("DD/MM/YYYY");
                    pr.showMoreMenu = false;
                    pr.typeClass = pr.prType.toLowerCase().replace(' - ', '-').split(' ').join('-');
                    pr.hovered = false;
                });

                if (this.pressReleases.length === 0) {
                    console.warn("No PR found for current filters & tab");
                }

            } catch (error) {
                if (error.response && error.response.status === 404) {
                    this.pressReleases = [];
                    this.filteredDraft = [];
                    this.filteredCompleted = [];
                    this.completedCount = 0;
                    this.draftCount = 0;
                } else {
                    console.error("Error while fetching press releases: ", error);
                }
            } finally {
                this.prLoader = false;
            }
        },


        addNewPr(data) {
            this.buttonLoader = true;
            const payload = {
                prTypeId: data.prType,
                prName: data.docName
            }
            axiosInstance.post('/pr/create', payload)
                .then((response) => {
                    if (response.status === 201) {
                        this.$router.push(`/pr/${response.data.data.prId}`);
                    }
                })
                .catch((error) => {
                    console.error('Error while creating new PR: ', error);
                })
                .finally(() => {
                    this.buttonLoader = false;
                    this.newPrDialog = false;
                })
        }
    },

    async mounted() {
        this.prLoader = true;
        this.selectedTab = this.$route.query.status ? this.$route.query.status.toLowerCase() : 'draft';
        await this.fetchPrTypes();
        await this.fetchAllPr();

    }
};
</script>

<style scoped>
.press-release {
    width: 100%;
    height: 100%;
    padding: 2rem;
    gap: 20px;
    display: flex;
    flex-direction: column;
}

.title {
    font-size: var(--title-font-size);
    font-weight: bold;
    border-bottom: 16px;
    font-family: 'OverpassMono';
}

.action-bar {
    display: flex;
    gap: 1rem;
    margin-bottom: 2rem;
}

.pr-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 1.5rem;
    overflow-y: auto;
    scrollbar-width: thin;
}

.pr-card {
    display: flex;
    gap: 16px;
    border: 1px solid #E5E5E5;
    background: #FAFAFA;
    flex-direction: column;
    padding: 1rem;
    border-radius: 8px;
    cursor: pointer;
}

.pr-table {
    width: 100%;
    border-collapse: collapse;
}

.pr-type {
    display: flex;
    width: fit-content;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    padding: 1px 13px;
}

.more-options-contaioner {
    min-width: 180px;
    display: flex;
    flex-direction: column;
    background: white;
    border: 1px solid #E5E5E5;
    border-radius: 8px;
    box-shadow: 0px 4px 8px 0px #0000000F, 0px 0px 4px 0px #0000000A;
}

.bottom-border {
    border-bottom: 1px solid #E5E5E5;
}

.more-option-img-wrapper {
    display: flex;
    gap: 8px;
    align-items: center;
    cursor: pointer;
    padding: 1rem;
}

.table-pr-type {
    display: flex;
    width: fit-content;
    align-items: center;
    justify-self: center;
}

.general {
    color: #33AC37;
    background: #ECFFEC;
    border: 1px solid #D1F5D3;
    font-weight: 500;
}

.product-launch {
    color: #0095FF;
    border: 1px solid #E3F2FF;
    background: #F0F9FF;
    font-weight: 500;
}

.table-pr-type.general {
    padding: 0.3rem 1rem;
    border-radius: 4px;
    color: #33AC37;
    background: #ECFFEC;
    border: 1px solid #D1F5D3;
    font-weight: 500;
}

.table-pr-type.product-launch {
    padding: 0.3rem 1rem;
    border-radius: 4px;
    color: #0095FF;
    background-color: #F0F9FF;
    border: 1px solid #E3F2FF;
    font-weight: 500;
}

.table-pr-type.announcements {
    color: #FF4856;
    font-weight: 500;
}

.table-pr-type.event-announcement {
    padding: 0.3rem 1rem;
    border-radius: 4px;
    color: #FF27DE;
    background-color: #FFF0FD;
    border: 1px solid #FFE3FD;
    font-weight: 500;
}

.table-pr-type.funding\/m\&a {
    padding: 0.3rem 1rem;
    border-radius: 4px;
    color: #FF900A;
    background: #FFF9EC;
    border: 1px solid #FFF3D3;
    font-weight: 500;
}

.pr-type.announcements {
    color: #FF4856;
    background: #FFE5E7;
    border: 1px solid #FF969E;
    font-weight: 500;
}

.pr-type.funding\/m\&a {
    color: #FF900A;
    background: #FFF9EC;
    border: 1px solid #FFF3D3;
    font-weight: 500;
}

.pr-type.event-announcement {
    color: #FF27DE;
    border: 1px solid #FFC6FB;
    background: #FFF0FD;
    font-weight: 500;
}

.pr-content {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    font-weight: 600;
}

.pr-footer {
    display: flex;
    padding-top: 12px;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #E5E5E5;
    font-size: 14px;
    color: #525252;
}

.avatar {
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 8px;
}

.meta-info {
    display: flex;
    flex-direction: row;
}

.author {
    font-weight: 500;

}

.timestamp {
    font-weight: 500;
    color: #A3A3A3
}

.mainComponents {
    display: flex;
    background: white;
    gap: 1rem;
    flex-grow: 1;
    border-radius: 16px;
}

.TitleSection {

    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.new-pr-container {
    display: flex;
    background: black;
    flex-direction: row;
    color: var(--secondary-font-color);
    border-radius: 8px;
    align-items: center;
    gap: 8px;
    padding: 0.8rem 1.8rem;
    font-family: 'OverpassMono';

}

.filter-Page {
    display: flex;
    gap: 10px;
    justify-content: center;
}

.selected-date-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    height: 40px;
    padding: 4px 8px;
    border-radius: 8px;
    border: 1px solid #D4D4D4;
    color: #030712;
}

.filter-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
}

.text {
    font-size: 14px;
}

.action-btns {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.ok-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #A3A3A3;
    border-radius: 4px;
}

.toggle-buttons {
    display: flex;
    gap: 10px;
    border: 1px solid #A3A3A3;
    padding: 4px;
    border-radius: 8px;

}

.toggle-button {
    padding: 10px 30px;
    border-radius: 8px;
    font-family: monospace;
    text-transform: uppercase;
}

.toggle-button.active {
    background-color: black;
    color: white;
}

.toggle-button:hover {
    background-color: black;
    color: white;
}

.toggle-container {
    display: flex;
    justify-content: space-between;

}

.PRtypecontent {

    display: flex;
    gap: 12px;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    gap: 16px;
    width: 191px;
    padding: 14px;
    border-radius: 26px;
    border: 1px solid #A3A3A3;

}

.body-content {
    display: flex;
    flex-direction: column;
    gap: 25px;
    height: 89%;
}

.popup {
    display: flex;
    flex-direction: column;
    background: white;
    border: 1px solid #E0E9ED;
    border-radius: 8px;
}

.popup-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    font-weight: 600;
    font-family: monospace;
    font-size: 20px;
}

.circle {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    padding: 8px;
    border: 2px solid #D4D4D4;
}

.popup-body {
    display: flex;
    flex-direction: column;
    gap: 1em;
    padding: 0px 16px 16px 16px;
    overflow: auto;
    height: 100%;
}

.popup-footer {
    display: flex;
    justify-content: space-between;
    gap: 1em;
}

.add-new-btn-continue {
    display: flex;
    align-items: center;
    gap: 25px;
    justify-content: center;
    width: 50%;
    background: #171717;
    color: white;
    border: 1px solid #525252;
    border-radius: 12px;
    font-weight: 500;
}

.add-new-btn {
    width: 50%;
    padding: 12px;
    background: white;
    border: 1px solid #525252;
    border-radius: 12px;
    font-weight: 500;
}

button:disabled {
    cursor: not-allowed;
    opacity: 0.7;
}

.popup-input {

    display: flex;
    flex-direction: column;
    gap: 12px;
    font-weight: 400;
}

.pr-filter-select {
    min-width: 150px;

}

.pr-filter-select :deep(.v-field__clearable) {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 0 4px;
}

.pr-filter-select :deep(.v-field__clearable .v-icon) {
    font-size: 18px;
    line-height: 1;
}

.pr-filter-select :deep(.v-field) {
    border: 1px solid #D4D4D4 !important;
}

.pr-filter-select :deep(.v-field) {
    height: 40px !important;
    border-radius: 8px !important;
    display: flex;
    align-items: center;
}

.pr-filter-select :deep(.v-field__input) {
    display: flex;
    align-items: center;
    height: 100%;
    padding: 0 12px;
    font-size: 14px;
}

.pr-filter-select :deep(.v-select__selection) {
    display: flex;
    align-items: center;
}

.pr-filter-select :deep(.v-field__append-inner) {
    display: flex;
    align-items: center !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    height: 100%;
}

.no-data {
    width: 100%;
    height: 100%;
    padding: 2rem;
    gap: 20px;
    display: flex;
    overflow: auto;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.profile-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    width: 25px;
    height: 25px;
    overflow: hidden;
    font-size: 14px;
}

.no-avatar {
    background: linear-gradient(90deg, #FF00C3, #FF0A19, #FF7800);
    color: white;
}

.pr-more-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.view-toggle-container {
    display: flex;
    border: 1px solid #D4D4D4;
    height: 38px;
    border-radius: 8px;
}

.view-icon {
    display: flex;
    align-items: center;
    padding: 8px 16px;
}

.view-icon.active:first-child {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    background-color: #F1F4FB;
}

.view-icon.active {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    background-color: #F1F4FB;
}

.view-icon:first-child {
    border-right: 1px solid #D4D4D4;
}

.view-icon.active svg {
    fill: #171717;
}

.Avatar {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin-right: 8px;
}

.table-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 85%;
    justify-content: space-between;
}

.table-container :deep(.v-table__wrapper tr:hover) {
    background: #F1F4FB !important;
}

.more-button-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #E5E5E5;
    width: 2rem;
    height: 2rem;
    border-radius: 8px;
}



.table-wrapper {
    border-radius: 8px;
    height: 100%;
    scrollbar-width: thin;
    justify-content: center;
    will-change: transform;
    align-items: end;
}

.table-wrapper :deep(.v-table__wrapper) {
    width: 100%;
    scrollbar-width: thin;
    border-radius: 8px;
    border: 1px solid #E5E5E5;

}

.table-wrapper :deep(.v-table__wrapper thead) {
    position: sticky;
    top: 0;
    z-index: 1000;
    background: #F1F4FB !important;
}

.table-wrapper :deep(.v-table__wrapper thead tr th) {
    font-weight: 600 !important;
    color: var(--primary-font-color);
}

.table-wrapper :deep(.v-table__wrapper tbody) {
    max-height: 700px;
    color: var(--dark-grey-color);
}

.table-wrapper :deep(.v-data-table-footer) {
    background: #F1F4FB !important;
    padding: 0rem 0rem 0rem 1rem;
    margin: 1rem;
    height: 5rem;
    border-radius: 8px;
    border: 1px solid #E5E5E5;
}

.table-wrapper :deep(.v-data-table-footer .v-pagination__list .v-pagination__first) {
    display: none;
}

.table-wrapper :deep(.v-data-table-footer .v-pagination__list .v-pagination__last) {
    display: none;
}

.table-wrapper :deep(.v-data-table-footer .v-input__control) {
    height: 2rem;
    width: 4rem;
}

.table-wrapper :deep(.v-data-table-footer .v-input__control .v-field__input) {
    padding: 0px 16px 8px 16px;
    font-size: 14px;
}

.table-wrapper :deep(.v-data-table-footer .v-input__control .v-field__field) {
    height: 2rem;
    width: 3rem;
}

.table-wrapper :deep(.v-data-table-footer .v-input__control .v-field__append-inner) {
    width: 1rem;
}

.table-wrapper :deep(.v-data-table-footer .v-data-table-footer__items-per-page > .v-select) {
    width: 63px;
    background: #ffffff;
}

.prName-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 2rem;
}

.icon-wrapper {
    display: flex;
    background-color: white !important;
    border: 1px solid #E5E5E5;
    width: 2rem;
    height: 2rem;
    transition: 0.2s ease-in-out;
    justify-content: center;
    align-items: center;
    border-radius: 0.5rem;
}

.editable {
    display: flex;
    align-items: center;
    position: relative;
}

.editable .edit-icon {
    margin-left: 8px;
    color: #007bff;
    cursor: pointer;
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
}

.editable:hover .edit-icon {
    visibility: visible;
    opacity: 1;
}

.pagination-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0.5rem;
}


.no-press-release {
    display: flex;
    flex-direction: column;
    padding: 2rem;
    border: 1px solid #E5E5E5;
    border-radius: 12px;
    background-color: #FAFAFA;
    gap: 20px;
    flex: 1;
}

.no-pr-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;
    gap: 0.5rem;
}

.no-pr-text {
    font-size: var(--header-font-size);
    font-weight: 600;
}

.no-pr-sub-text {
    font-size: var(--normal-font-size);
    color: var(--dark-grey-color);
}
</style>
